import {MouseEvent} from 'react';
import I18n from 'app/i18n';
import {modalConfirm} from 'app/utils/modals/popups';
import {startCasinoGame} from 'app/services/CasinoServices';
import {hideLastPopup} from 'app/utils/modals/ModalsService';
import FreespinInterface from 'app/interfaces/Freespinsinterface';
import {UserBonusesStore} from 'app/store/UserBonusesStore';
import {goToRoute} from 'app/utils';
import {getTableLinkPath} from 'app/utils/link_helper';
import freeSpins10 from 'images/freespins/freespins-10.png';
import freeSpins20 from 'images/freespins/freespins-20.png';
import freeSpins30 from 'images/freespins/freespins-30.png';
import freeSpins40 from 'images/freespins/freespins-40.png';
import freeSpins50 from 'images/freespins/freespins-50.png';
import freeSpins75 from 'images/freespins/freespins-75.png';
import freeSpins100 from 'images/freespins/freespins-100.png';

export const handleActivateClick = (
    e: MouseEvent<HTMLButtonElement>,
    gameId: string,
    options: { casino_page?: boolean } = {}
): void => {
    e.preventDefault();
    if (options.casino_page) {
        hideLastPopup();
    } else {
        goToRoute(getTableLinkPath('/casino'));
    }
    startCasinoGame(Number(gameId));
};


export const handleCancelClick = (
    e: MouseEvent<HTMLButtonElement>,
    spin: FreespinInterface,
    userBonusesStore: UserBonusesStore
): void => {
    e.preventDefault();
    modalConfirm(
        I18n.t('casino_free_spins.confirm_deactivate', {count: spin.quantity, name: spin.game}),
        () => userBonusesStore.cancelFreeSpin(spin.id)
    );
};

export const getActivateClickHandler = (
    gameId: string,
    options: { casino_page?: boolean } = {}
) => (e: MouseEvent<HTMLButtonElement>): void => handleActivateClick(e, gameId, options);

export const getCancelClickHandler = (
    spin: FreespinInterface,
    userBonusesStore: UserBonusesStore
) => (e: MouseEvent<HTMLButtonElement>): void => handleCancelClick(e, spin, userBonusesStore);

const freeSpinsQuantityImages: Record<number, string> = {
    10: freeSpins10,
    100: freeSpins100,
    20: freeSpins20,
    30: freeSpins30,
    40: freeSpins40,
    50: freeSpins50,
    75: freeSpins75
};

export const getFreeSpinsQuantityImage = (quantity: number): string => freeSpinsQuantityImages[quantity] ?? freeSpins10;
